var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-list-overview',{attrs:{"controller":"Monitor","filter":_vm.Filter,"link-controller":"Child/Monitor","link-key":_vm.link.key,"link-table":"","redirect":"","redirect-page":"Monitors","rights":_vm.Rights,"tab":"monitors","type":"monitor","visible":_vm.visible}})
}
var staticRenderFns = []

export { render, staticRenderFns }